import { CollecttotalindiandataService } from './services/collecttotalindiandata.service';
import { CollectindiadataService } from './services/collectindiadata.service';
import { CollectdataService } from './services/collectdata.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CountrywiseComponent } from './countrywise/countrywise.component';
import { CountriwiseindiaComponent } from './countriwiseindia/countriwiseindia.component';
import { HomepagecomponentComponent } from './homepagecomponent/homepagecomponent.component';
import { NavbarComponent } from './navbar/navbar.component';
import { StatewisecomponentComponent } from './statewisecomponent/statewisecomponent.component';
import { InfoComponent } from './info/info.component';
import { ImgComponent } from './img/img.component';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    CountrywiseComponent,
    CountriwiseindiaComponent,
    HomepagecomponentComponent,
    NavbarComponent,
    StatewisecomponentComponent,
    InfoComponent,
    ImgComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
  ],
  providers: [
    CollectdataService,
    CollectdataService,
    CollectindiadataService,
    CollecttotalindiandataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
